export default __webpack_public_path__ + "assets/img/withdrawApplication.affb267b45b0ca7f2ea940b106df0132.png";